import type {
  BuilderComponent,
  DynamicImportComponentDetail,
} from 'hb-builder/types';

export interface LoadedComponents {
  [key: string]: BuilderComponent;
}

const formatComponentsList = (loadedComponents: LoadedComponents[]) =>
  loadedComponents.reduce((acc, curr) => ({ ...acc, ...curr }), {});

export const loadComponents = async (
  componentNameList: DynamicImportComponentDetail[],
) => {
  if (!componentNameList) {
    return undefined;
  }

  const loadedComponents = await Promise.all(
    componentNameList.map(async ({ folder, label, name }) => {
      const component = await import(
        /* webpackExclude: /__test__|__tests__|__mocks__/ */
        /* webpackMode: "eager" */
        `hb-builder/components/BuilderComponents/${folder}/${name}`
      );

      return { [label]: component.default };
    }),
  );

  return formatComponentsList(loadedComponents);
};
